module.exports = __webpack_public_path__ + "static/media/benefits-background.fe78de12.png";